import { InputControlsContext } from '@trinity/chat-components/components/BrandInsights/context';
import { useContext, useCallback } from 'react';
import { ChatLoggerContext } from '@trinity/chat-components/containers/Chat';

export const useChatTextInputControls = () => {
  const { textAreaRef } = useContext(InputControlsContext);
  const loggerCtx = useContext(ChatLoggerContext);

  const focusChatInputTextArea = useCallback(() => {
    try {
      textAreaRef.current?.focus();
    } catch (error) {
      loggerCtx.setContext('TextAreaFocusError', { textAreaExists: !!textAreaRef.current });
      loggerCtx.captureException(error);
    }
  }, [loggerCtx, textAreaRef]);

  return {
    focusChatInputTextArea,
  };
};